import { EventMappingType, EventStatus, EventType, SpecialOfferType } from '../enums';
import { IBet } from '../bet/bet';
import { IEventLiveResultInfo } from './eventLiveResultInfo.interface';
import { IBetGroupWithBetToShowId } from '../bet/betGroupWithBetToShow.interface';

export class EventVM {
  id: number;
  code: string;
  dateTime: Date;
  competitionId: number;
  regionId: number;
  sportId: number;
  competitionName: string;
  isPlayable: boolean;
  isInOffer: boolean;
  eventName: string;
  isLive: boolean;
  betGroups: { [betTypeId: number]: IBetGroupWithBetToShowId } = {};
  homeTeam: string;
  awayTeam: string;
  homeTeamShort: string;
  awayTeamShort: string;
  betsCount: number;
  cashBackEnabled: boolean;
  betRadarEventId?: number;
  result?: IEventLiveResultInfo;
  playableBetsCount: number;
  selectedBetTypeId: number;
  regionName: string;
  sportName: string;
  orderNo: number;
  // betsToShow: {[betTypeId: number]: Bet} = {};
  // for later mapping type and siblingEventId are missing on cache object
  mappingType: EventMappingType;
  siblingdEventId: number;
  eventDate: string;
  eventTime: string;
  eventType: EventType;
  streamUrl: string = null;
  liveStreamId: number = null;
  isExpanded = false;
  isInFavorite = false;
  isCompetiionInFavorite = false;
  isNotificationEnabled = false;
  status: EventStatus;

  specialOfferType: SpecialOfferType;

  constructor(){
    this.betGroups = {};
  }

  updateEventDetails(event: EventVM) {
    this.code = event.code;
    this.dateTime = event.dateTime;
    this.eventDate = event.eventDate;
    this.eventTime = event.eventTime;
    this.cashBackEnabled = event.cashBackEnabled;
    this.isPlayable = event.isPlayable;
    this.isInOffer = event.isInOffer;
    this.eventName = event.eventName;
    this.homeTeam = event.homeTeam;
    this.awayTeam = event.awayTeam;
    this.cashBackEnabled = event.cashBackEnabled;
    this.playableBetsCount = event.playableBetsCount;
    this.status = event.status;
    // this.betsCount = event.betsCount;
  }
}
